import { Component, HostBinding, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AppServiceService } from '../../../api/app-service.service';
import { ModalPopoverPage } from "../shared/modal-popover/modal-popover.page";
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-weblanding',
  templateUrl: './weblanding.page.html',
  styleUrls: ['./weblanding.page.scss'],
  encapsulation: ViewEncapsulation.None,
})

export class WeblandingPage implements OnInit {

  @ViewChild('slider') slider;

  tempDishcar: any = [];
  slideOpts = {
    initialSlide: 8,
    speed: 400,
    autoplay: true,
    slidesPerView: 4,
  };

  mostPopularDishes: any = [];
  stepTextsAndIcons: any = [];
  metaData: any = {};

  initializeAttempts: number = 0;
  baseURL: string = '';

  iOsLink: string = '';
  androidLink: string = '';

  @HostBinding('style.--favourite-restaurant-icon')
  public favRestaurantIcon: string = '#ffbc00';

  constructor(public appService: AppServiceService, public modalController: ModalController, public router: Router) {
    this.baseURL = environment.BASE_URL;
    appService.isWebVersion = true;
    appService.themeConfigFor = 'web'
  }

  async ngOnInit() {
    // await this.appService.getRestaurantBySlug('my-chicken');
    // this.getMostPopularDishes();
    // this.fetchMetaData();
    this.initWebApp();

    this.appService.triggerSettingsLoadedSuccssfulyCallback().subscribe((response) => {
      this.fetchHighlightList();
      this.fetchBranchesList();

      if (this.appService.appObject.settings && this.appService.appObject.settings.ios_link) this.iOsLink = this.appService.appObject.settings.ios_link;
      if (this.appService.appObject.settings && this.appService.appObject.settings.android_link) this.androidLink = this.appService.appObject.settings.android_link;
    });

    // setTimeout(() => {
    //   this.ionViewDidEnter();
    //   this.tempDishcar = ['', '', '', '', '', '', ''];
    // }, 500);

  }

  ngDoCheck() {
    if (this.appService.appObject.theme && this.appService.appObject.theme.web && this.appService.appObject.theme.web.favouriteRestaurantButtonBackground)
      this.favRestaurantIcon = this.appService.appObject.theme.web.favouriteRestaurantButtonBackground;
  }

  /**
   * When the device is not registered before (like in incognito mode in chrome),
   * below api request won't work, so until the device registration process done,
   * have set a timeout to keep check sevaral times wether device registered or not,
   * once it get registered, below api request are good to go
   */
  initWebApp() {
    if (this.appService.appObject.userId) {
      // this.getMostPopularDishes();
      this.fetchMetaData();
    } else if (this.initializeAttempts < 5) { // 5 attempts
      console.log('Waitng till the device get registered (attempt ' + (1 + this.initializeAttempts) + ')');
      setTimeout(() => {
        this.initWebApp();
        this.initializeAttempts++;
      }, 3500);
    }
  }

  ionsliderNext() {
    if (this.slider) this.slider.slideNext();
  }


  ionsliderBack() {
    if (this.slider) this.slider.slidePrev();
  }

  ionViewDidEnter() {
    if (this.slider) this.slider.onlyExternal = true;
    // this.slider.lockSwipes(true);
  }

  getHomeAppImageURL() {
    // + '?randomize=' + new Date().getTime()
    return this.appService?.appObject?.baseUrl + '/images/restaurant-web-home-app-img/' + this.appService?.appObject?.settings?.main_restaurant?.id;
    // return new Date().getTime();
  }

  async presentModal(type) {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.select_order_type',
        'type': type
      }
    });

    await modal.present();
    const { data } = await modal.onWillDismiss();
    return data;
  }

  /**
   * Fetch web app meta data
   */
  async fetchMetaData() {
    this.appService.appObject.isLoading = true;
    await this.appService.getWebAppLandingPageMetaData().then((response: any) => {
      if (response && response.status) {
        this.metaData = response.data.openDetails ? JSON.parse(response.data.openDetails) : {};
      }
    }).catch((error) => {
      this.metaData = {};
      console.log('Meta Data Error : ', error);
    });
    this.appService.appObject.isLoading = false;
  }

  /**
   * Fetch highlighted product list
   */
  fetchHighlightList() {
    // if franchise mode is on then, fetch highlights from favourite restaurant, otherwise fech from main restaurant
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration
      && (!this.appService.appObject.settings.app_configuration.has_multiple_restaurants || (this.appService.appObject.settings.is_franchise === 'true' && this.appService.appObject.favouriteRestaurant))
      && this.appService.appObject.settings.app_configuration.show_highlights) {
      this.appService.appObject.isLoading = true;
      this.appService.fetchHighlightProducts((this.appService.appObject.settings.is_franchise === 'true' && this.appService.appObject.favouriteRestaurant) ? this.appService.appObject.favouriteRestaurant.id : null).then((response: any) => {
        if (response.status) {
          this.mostPopularDishes = response.data;
        }
        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        this.appService.appObject.isLoading = false;
      })
    }
  }

  /**
   * Fetch all branches
   */
  fetchBranchesList() {
    this.appService.appObject.restaurants = [];
    if (this.appService.isSettingsLoaded && this.appService.appObject.settings.app_configuration && this.appService.appObject.settings.app_configuration.show_branches) {
      this.appService.fetchAllRestaurants(true).then((response) => {
        // if (response === 'done') {
        //   console.log('restaurants : ', this.appService.appObject.restaurants);
        // }
      }).catch((error) => {
        console.log('error : ', error);
      })
    }
  }

  /**
   * User will navigate into selected branch's menu page
   * @param branch selected branch to navigate into
   */
  async navigateToBranchMenu(branch) {
    // clear if any previously added address errors
    this.appService.appObject.errors && this.appService.appObject.errors.address ? this.appService.appObject.errors.address = '' : '';
    if (branch && branch.slug) {
      const modal = await this.modalController.create({
        component: ModalPopoverPage,
        cssClass: 'order-popup',
        componentProps: {
          'title': 'key.select_order_type',
          'type': 'delivery-type',
          'selectedBranch': branch
        }
      });

      await modal.present();
      // this.appService.getRestaurantBySlug(branch.slug).then((response) => {
      //   this.router.navigate(['/menu']);
      // });
    }
  }

  /**
   * Open selected favourite restaurant delivery type select popup
   */
  async openFavouritePopup() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.select_order_type',
        'type': 'delivery-type',
        'fromFavouriteIcon': true
      }
    });

    await modal.present();
  }

  async openChangeFavouriteRestaurant() {
    const modal = await this.modalController.create({
      component: ModalPopoverPage,
      cssClass: 'order-popup',
      componentProps: {
        'title': 'key.search_restaurants_nearby',
        'type': 'favourite_restaurant_search',
        'selectfavouriteRestaurant': true
      }
    });

    await modal.present();
  }
}
